module.exports = __webpack_public_path__ + "img/full3-min.65ee207b.png";